import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { OnpremiseServer } from '../api/models/onpremise-server';
import { SearchParams } from './onpremiseservers-list.component';

/**
 * Data source for the OnpremiseserversList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class OnpremiseserversListDataSource implements DataSource<OnpremiseServer> {

  private onpremiseServersSubject = new BehaviorSubject<OnpremiseServer[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private onpremiseServersCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.onpremiseServersCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<OnpremiseServer[]> {
    return this.onpremiseServersSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.onpremiseServersSubject.complete();
    this.loadingSubject.complete();
  }

  loadOnpremiseServers(params: SearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve onpremise servers */
    this.retrieveService.getOnpremiseServersList(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(contents => {
      // console.log(contents);
      this.onpremiseServersSubject.next(contents);
    });

    /* Count onpremise servers */
    this.retrieveService.getNumOnpremiseServers(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.onpremiseServersCount.next(count as number);
    });
  }
}

